import { FC, PropsWithChildren, createContext, useContext } from 'react';
import { useLocalStorage } from 'mir-utils/hooks';
import { useViewport } from 'mir-utils/theme/useViewport';
import { useVersion } from 'mir-utils/api-tools';
import { Loading } from 'mir-utils/components';
import { IconWidgetHelpDeskEddyChat } from './IconWidgetHelpDeskEddyChat';

type SupportChatProviderType = PropsWithChildren<{
  isChatVisible: boolean;
}>;

const SupportChatContext = createContext<SupportChatProviderType>({
  isChatVisible: true,
});

export const useSupportChatContext = () => useContext(SupportChatContext);

export const SupportChatProvider: FC = ({ children }) => {
  const { isExpandedView } = useViewport();

  const version = useVersion();

  const [isChatVisible] = useLocalStorage('support-chat', true);

  if (version === undefined) {
    return <Loading />;
  }

  const isChatVisibleByViewport = isExpandedView ? isChatVisible : false;

  return (
    <SupportChatContext.Provider value={{ isChatVisible }}>
      {children}
      {isChatVisibleByViewport && (
        <IconWidgetHelpDeskEddyChat language={version.language === 'ru_RU' ? 'ru' : 'en'} />
      )}
    </SupportChatContext.Provider>
  );
};
